import { createContext, useContext, useEffect, useState } from "react";

export type TmplThemeName = "light" | "dark" | "system";
interface ThemeContextType {
	theme: TmplThemeName;
	setTheme: (theme: TmplThemeName) => void;
}

const ThemeContext = createContext<ThemeContextType>({
	theme: "light",
	setTheme: () => {},
});

export function useTheme(): TmplThemeName {
	const { theme } = useContext(ThemeContext);
	return theme;
}

export function useSetTheme(): (theme: TmplThemeName) => void {
	const { setTheme } = useContext(ThemeContext);

	function updateTheme(theme: TmplThemeName) {
		setTheme(theme);
		localStorage.setItem("theme", theme);
	}

	return updateTheme;
}

export const ThemeProvider = ({ children }: { children: React.ReactNode }) => {
	const [theme, setTheme] = useState<TmplThemeName>("light");
	const [isMounted, setIsMounted] = useState(false);

	useEffect(() => {
		document.body.classList.remove("light", "dark", "system");
		document.body.classList.add(theme);
	}, [theme]);

	useEffect(() => {
		const savedTheme = localStorage.getItem("theme");
		if (savedTheme) {
			setTheme(savedTheme as TmplThemeName);
		}
		setIsMounted(true);
	}, []);

	useEffect(() => {
		document.body.classList.remove("light", "dark", "system");
		document.body.classList.add(theme);
	}, [theme]);

	return (
		<ThemeContext.Provider value={{ theme, setTheme }}>
			<div id={"theme-provider"} className={`w-full h-full ${theme}`}>
				<div className="h-full w-full">{isMounted && children}</div>
			</div>
		</ThemeContext.Provider>
	);
};
